import { Field, Text, TextField } from '@sitecore-jss/sitecore-jss-nextjs';
import DocumentListings from 'components/Sections/DocumentListings';
import DocumentListingBase from 'components/Sections/DocumentListingBase';

type AccordionItem = {
  fields: {
    title?: TextField;
    editionId: Field<string>;
  };
  template: string;
};

type AccordionItemsProps = {
  items?: Array<AccordionItem>;
  hideTitle: boolean;
  className?: string;
};

const AccordionItems = ({ items = [], hideTitle = false, className }: AccordionItemsProps) => {
  return (
    <div className={className}>
      {items.map((item, index) => (
        <div key={index} className={index !== 0 ? 'mt-3' : ''}>
          {item.template === 'Automatic Document Listings' && item.fields.title && (
            <>
              <Text tag="h5" field={item.fields.title} className="mb-3" />
              <DocumentListingBase
                editionId={item.fields.editionId && item.fields.editionId.value}
              />
            </>
          )}

          {item.template !== 'Automatic Document Listings' && item.fields.title && (
            <>
              <Text tag="h5" field={item.fields.title} className="mb-3" />
              <DocumentListings
                fields={item.fields}
                className="pt-0"
                hideTitle={hideTitle}
                rendering={undefined as any}
                params={undefined as any}
              />
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default AccordionItems;
